import { useContext } from 'react';
import ImageSupportContext from 'app/context/ImageSupportContext';

export const useImageSupport = () => {
  const context = useContext(ImageSupportContext);
  if (!context) {
    throw new Error('useImageSupport must be used within an ImageSupportProvider');
  }
  return context;
};
